"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _PFM4PJSGcjs = require('./PFM4PJSG.cjs');


var _MPIQVHCBcjs = require('./MPIQVHCB.cjs');




var _PTOCUU2Dcjs = require('./PTOCUU2D.cjs');


var _3BSDKDKDcjs = require('./3BSDKDKD.cjs');

// src/dialog/dialog-dismiss.tsx
var _react = require('react');
var _jsxruntime = require('react/jsx-runtime');
var TagName = "button";
var useDialogDismiss = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useDialogDismiss2({ store, ...props }) {
    const context = _PFM4PJSGcjs.useDialogScopedContext.call(void 0, );
    store = store || context;
    const onClickProp = props.onClick;
    const onClick = _3BSDKDKDcjs.useEvent.call(void 0, (event) => {
      onClickProp == null ? void 0 : onClickProp(event);
      if (event.defaultPrevented) return;
      store == null ? void 0 : store.hide();
    });
    const children = _react.useMemo.call(void 0, 
      () => /* @__PURE__ */ _jsxruntime.jsxs.call(void 0, 
        "svg",
        {
          "aria-label": "Dismiss popup",
          display: "block",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 1.5,
          viewBox: "0 0 16 16",
          height: "1em",
          width: "1em",
          children: [
            /* @__PURE__ */ _jsxruntime.jsx.call(void 0, "line", { x1: "4", y1: "4", x2: "12", y2: "12" }),
            /* @__PURE__ */ _jsxruntime.jsx.call(void 0, "line", { x1: "4", y1: "12", x2: "12", y2: "4" })
          ]
        }
      ),
      []
    );
    props = {
      "data-dialog-dismiss": "",
      children,
      ...props,
      onClick
    };
    props = _MPIQVHCBcjs.useButton.call(void 0, props);
    return props;
  }
);
var DialogDismiss = _PTOCUU2Dcjs.forwardRef.call(void 0, function DialogDismiss2(props) {
  const htmlProps = useDialogDismiss(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});




exports.useDialogDismiss = useDialogDismiss; exports.DialogDismiss = DialogDismiss;
